var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { sanitizeString } from '@/support/String';
let MiDialog = class MiDialog extends Vue {
    constructor() {
        super(...arguments);
        this.settings = null;
        this.okButton = false;
    }
    optionsChanged(options) {
        if (options === null) {
            return;
        }
        this.settings = this.options;
    }
    mounted() {
        if (this.options === null) {
            return;
        }
        this.settings = this.options;
    }
    cancel() {
        if (this.hasCancelButton && this.settings) {
            const button = this.settings.buttons.cancel;
            if (button.action) {
                button.action();
            }
        }
        this.close();
    }
    confirm() {
        if (this.hasConfirmButton && this.settings) {
            const button = this.settings.buttons.confirm;
            if (button.action) {
                button.action();
            }
        }
        this.close();
    }
    close() {
        this.$emit('input', false);
        this.$emit('close', true);
    }
    get hasCancelButton() {
        if (!this.settings || !this.settings.buttons || !this.settings.buttons.cancel) {
            return false;
        }
        return this.settings.buttons.cancel.text !== '';
    }
    get hasConfirmButton() {
        if (!this.settings || !this.settings.buttons || !this.settings.buttons.confirm) {
            return false;
        }
        if (this.settings.buttons.confirm.text.toLowerCase() ===
            this.$t('dialogOptions.button.ok')
                .toString()
                .toLowerCase() ||
            this.settings.buttons.confirm.text.toLowerCase() === 'ok') {
            this.okButton = true;
        }
        else {
            this.okButton = false;
        }
        return this.settings.buttons.confirm.text !== '';
    }
    sanitizeString(value) {
        return sanitizeString(value);
    }
};
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Object)
], MiDialog.prototype, "options", void 0);
__decorate([
    Watch('options'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MiDialog.prototype, "optionsChanged", null);
MiDialog = __decorate([
    Component({
    //
    })
], MiDialog);
export default MiDialog;
